import { useState } from 'react';
import type { FormEvent } from 'react';
import { useAuth } from '../lib/auth.tsx';
import { Field } from '../components/ui.tsx';
import { LoginSmoke } from '../components/LoginSmoke.tsx';
import { LoginAtmosphere } from '../components/LoginAtmosphere.tsx';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(
    () => new URLSearchParams(window.location.search).get('googleError'),
  );
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível entrar.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login">
      <LoginSmoke />
      <LoginAtmosphere />
      <form className="login__card card card--raised" onSubmit={onSubmit}>
        <div className="login__brand">
          <span className="login__ring-wrap" aria-hidden="true">
            <span className="login__ring-halo" />
            <span className="login__ring" />
            <img className="login__ring-logo" src="/landing/evanescence-e.png" alt="" />
          </span>
          <div>
            <h1 className="login__brand-name">EvShadow</h1>
            <p className="login__brand-tagline">Central de operação</p>
          </div>
        </div>

        <Field label="E-mail ou usuário">
          <input
            className="input"
            type="text"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>

        <Field label="Senha">
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>

        {error && (
          <p className="state-error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? 'Entrando…' : 'Entrar'}
        </button>

        <div className="login__divider" role="separator">
          <span>ou</span>
        </div>

        <a href="/api/auth/google" className="btn btn-ghost">
          Continuar com Google
        </a>
      </form>
    </div>
  );
}
